import * as React from 'react';

import {Button} from '../button/button';
import {ButtonMover} from '../button-mover/button-mover';

type Props = {
    onClick: () => void;
    text: string;
};

export function TextButtonCell(props: Props) {
    return (
        <ButtonMover direction='left' size='big'>
            <Button variant='text-primary' size='big' onClick={props.onClick}>
                {props.text}
            </Button>
        </ButtonMover>
    );
}
